module.exports = __webpack_public_path__ + "img/coupon.fceb6caa.svg";